import type { FormState } from "@/shared/form";
import type Current from "./current";

export const currentKey = Symbol("current") as InjectionKey<Current>;
export const formKey = Symbol("formState") as InjectionKey<FormState>;

export function useCurrent(): Current {
  return injectBang(currentKey);
}

//
// Helpers
//

// Inject with runtime error if key has not been provided
export function injectBang<T>(key: InjectionKey<T>) {
  const provided = inject(key);
  if (!provided) {
    throw new Error(`could not inject ${key.toString()}`);
  }
  return provided;
}
